module.exports = __webpack_public_path__ + "static/media/PushtimargImage11.3a96d69e.jpg";